import script from "./Auth2.vue?vue&type=script&setup=true&lang=js"
export * from "./Auth2.vue?vue&type=script&setup=true&lang=js"

import "./Auth2.vue?vue&type=style&index=0&id=0952af5c&scoped=true&lang=css"

import exportComponent from "D:\\Workspace\\na-doskah.ru\\crm.na-doskah.ru.v1.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0952af5c"]])

export default __exports__